<nav class="navbar navbar-icon-top navbar-expand-lg navbar-dark bg-dark sticky-top">
  <a href="#" class="navbar-brand" routerLinkActive="active" [routerLink]="['/dashboard']">
    <!-- Logo Image -->
    <img src="https://www.b3-tech.co.th/wp-content/uploads/2021/01/LOGO-TECHNOLOGY.png" width="45" alt=""
      class="d-inline-block align-middle mr-2" />
    <!-- Logo Text -->
    <span class="text-uppercase font-weight-bold ">B3</span>
  </a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mx-auto nav justify-content-center navbar-icon">
      <li *ngFor="let menuItem of listTitles" class="{{ menuItem.class }} nav-item ml-3">
        <a [class.active]="isRouteActive(menuItem.path)" [routerLink]="[menuItem.path]" class="nav-link">
          <i class=" ni {{ menuItem.icon }}"></i>
          {{ menuItem.title }}
          <span class="sr-only"> {{ menuItem.title }}</span>
        </a>
      </li>
    </ul>

    <ul class="navbar-nav align-items-center d-m-none d-m-flex">
      <li class="nav-item" ngbDropdown placement="bottom-right">
        <a class="nav-link pr-0" role="button" ngbDropdownToggle>
          <div class="media align-items-center">
            <span class="avatar avatar-sm rounded-circle">
              <img alt="Image placeholder" src="assets/img/icons/user.png" />
            </span>
            <div class="media-body ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm font-weight-bold">{{ fullname }}</span>
            </div>
          </div>
        </a>
        <div class="dropdown-menu-arrow dropdown-menu-right" ngbDropdownMenu>
          <div class="dropdown-header noti-title">
            <h6 class="text-overflow m-0">Welcome!</h6>
          </div>
          <a routerLinkActive="active" [routerLink]="['/edit-profile']" class="dropdown-item">
            <i class="fa fa-pencil-square-o"></i>
            <span>Edit Profile</span>
          </a>
          <a routerLinkActive="active" [routerLink]="['/user-profile']" class="dropdown-item">
            <i class="ni ni-settings-gear-65"></i>
            <span>Change Password</span>
          </a>
          <a style="cursor: pointer;" (click)="popupTime(importCSV)" class="dropdown-item" *ngIf="role.includes('1')">
            <i class="fa fa-cloud-upload"></i>
            <span>Upload Holiday</span>
          </a>
          <div class="dropdown-divider"></div>
          <a [routerLink]="['/logout']" class="dropdown-item">
            <i class="ni ni-user-run"></i>
            <span>Logout</span>
          </a>
          <ng-template #importCSV let-modalUp>
            <div id="form-modal">
              <div class="modal-header">
                <h2 style="padding-top: 1%; padding-left: 32%; font-size: 28px">
                  IMPORT FILE
                </h2>
              </div>
              <div class="modal-body" style="text-align: center;">
                <button style="
                background-color: #008000;
                color: white;
                border-color: #008000;
                " class="btn btn-success btn-adduser" (click)="onExportHoliday()">
                  <span class="hover-text">Export Template</span>
                </button>
              </div>
              <div class="modal-body">
                <input type="file" (change)="onFileSelected($event)" style="padding-left: 26%" />
              </div>
            </div>
            <div style="
                padding-left: 26%;
                padding-bottom: 25px;
                padding-top: 30px;
              ">
              <h4 style="color: red; text-align: left">
                *นำไฟล์จาก ปุ่ม Export Template มา Import*
              </h4>
              <button [disabled]="!hasSelectedFiles" style="padding-left: 33px; padding-right: 33px;
                background-color: #2dce8a;
                color: white;
                border-color: #2dce8a;" class="btn btn-success" type="submit" (click)="addCalendar()">
                ADD
              </button>
              <button style="margin-left: 25px" class="btn btn-danger btn-adduser" (click)="funcCloseMOdel(modalUp)">
                CANCEL
              </button>
            </div>
          </ng-template>
        </div>
      </li>
    </ul>
  </div>
</nav>

<table hidden #tableHoliday style="text-align: center;">

  <thead style="background-color: whitesmoke;">
    <tr>
      <th colspan="3">
        <h1>วันหยุดประจำปี</h1>
      </th>
    </tr>
    <tr>
      <th scope="col" class="text-center">
        No
      </th>
      <th scope="col" class="text-center">
        Date
      </th>
      <th scope="col" class="text-center">
        Day_Description
      </th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td>1/1/{{ year+1 }}</td>
      <td>วันขึ้นปีใหม่</td>
    </tr>
  </tbody>
</table>